/**
 * Removes trailing protocol-type suffixes (RPC, WS, REST) from endpoint names.
 * e.g. "Ethereum Mainnet RPC" → "Ethereum Mainnet"
 */
export function stripProtocolSuffix(name: string): string {
  return name.replace(/\s+(RPC|WS|REST)$/i, '').trim();
}
